import { removeParamsFromQuery } from '@marketplace-web/shared/utils'

export const removeLocaleUrlParam = (relativeUrl: string, urlQuery: string) =>
  removeParamsFromQuery(relativeUrl, urlQuery, ['locale'])
